var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from 'react';
import { useDrag } from 'react-dnd';
import { Icon } from '@/assets/icons/LibrarySvg';
import { tileButton } from '@/components/Board/commonToolbarStyles';
import ConfirmModal from '@/components/UI/ConfirmModal';
export const NOTE_TYPE = 'NOTE';
const NoteListItem = ({ note, isSelected = false, onSelect, onDelete }) => {
    const [confirmOpen, setConfirmOpen] = useState(false);
    const [{ isDragging }, drag] = useDrag({
        type: NOTE_TYPE,
        item: () => ({ note }),
        collect: (monitor) => ({
            isDragging: monitor.isDragging(),
        }),
    });
    const dragRef = (node) => {
        drag(node);
    };
    const backgroundColor = isSelected ? 'rgba(255, 255, 255, 0.06)' : 'rgba(255, 255, 255, 0.01)';
    const borderColor = isSelected ? 'rgba(255, 255, 255, 0.1)' : 'transparent';
    return (_jsxs("div", { ref: dragRef, onClick: () => onSelect(note), style: {
            display: 'flex',
            alignItems: 'flex-start',
            justifyContent: 'space-between',
            gap: 12,
            padding: '10px 16px',
            borderRadius: 10,
            backgroundColor,
            border: `1px solid ${borderColor}`,
            cursor: 'pointer',
            pointerEvents: 'auto',
            opacity: isDragging ? 0.5 : 1,
            transition: 'all 0.15s ease',
        }, role: "button", "aria-label": `Открыть заметку ${note.name}`, tabIndex: 0, onKeyDown: (e) => {
            if (e.key === 'Enter' || e.key === ' ') {
                e.preventDefault();
                onSelect(note);
            }
        }, onMouseEnter: (e) => {
            if (!isSelected) {
                e.currentTarget.style.backgroundColor = 'rgba(255, 255, 255, 0.03)';
                e.currentTarget.style.borderColor = 'rgba(255, 255, 255, 0.06)';
            }
        }, onMouseLeave: (e) => {
            if (!isSelected) {
                e.currentTarget.style.backgroundColor = backgroundColor;
                e.currentTarget.style.borderColor = borderColor;
            }
        }, children: [_jsxs("div", { style: {
                    display: 'flex',
                    flexDirection: 'column',
                    gap: 6,
                    overflow: 'hidden',
                    flex: 1,
                    minWidth: 0,
                }, children: [_jsx("div", { style: {
                            fontSize: 15,
                            fontWeight: 600,
                            color: '#e8eaed',
                            whiteSpace: 'nowrap',
                            overflow: 'hidden',
                            textOverflow: 'ellipsis',
                            lineHeight: 1.4,
                            letterSpacing: '-0.01em',
                        }, title: note.name, children: note.name }), note.text && (_jsx("div", { style: {
                            fontSize: 13,
                            color: '#9aa0a6',
                            overflow: 'hidden',
                            whiteSpace: 'pre-wrap',
                            wordWrap: 'break-word',
                            overflowWrap: 'break-word',
                            display: '-webkit-box',
                            WebkitLineClamp: 3,
                            WebkitBoxOrient: 'vertical',
                            lineHeight: 1.5,
                        }, title: note.text, children: note.text }))] }), _jsx("button", { type: "button", onClick: (e) => {
                    e.stopPropagation();
                    setConfirmOpen(true);
                }, onMouseDown: (e) => e.stopPropagation(), onTouchStart: (e) => e.stopPropagation(), "aria-label": "\u0423\u0434\u0430\u043B\u0438\u0442\u044C \u0437\u0430\u043C\u0435\u0442\u043A\u0443", style: Object.assign(Object.assign({}, tileButton(false, { padding: 8, minWidth: 36, height: 36 })), { background: 'rgba(255, 255, 255, 0.04)', border: '1px solid rgba(255, 255, 255, 0.1)', color: '#9aa0a6', opacity: 0.6, transition: 'all 0.15s ease', flexShrink: 0 }), onMouseEnter: (e) => {
                    e.currentTarget.style.opacity = '1';
                    e.currentTarget.style.background = 'rgba(220, 38, 38, 0.15)';
                    e.currentTarget.style.borderColor = 'rgba(220, 38, 38, 0.3)';
                    e.currentTarget.style.color = '#ef4444';
                }, onMouseLeave: (e) => {
                    e.currentTarget.style.opacity = '0.6';
                    e.currentTarget.style.background = 'rgba(255, 255, 255, 0.04)';
                    e.currentTarget.style.borderColor = 'rgba(255, 255, 255, 0.1)';
                    e.currentTarget.style.color = '#9aa0a6';
                }, children: _jsx(Icon, { name: "trash" }) }), _jsx(ConfirmModal, { isOpen: confirmOpen, onClose: () => setConfirmOpen(false), title: "\u0423\u0434\u0430\u043B\u0438\u0442\u044C \u0437\u0430\u043C\u0435\u0442\u043A\u0443?", confirmText: "\u0423\u0434\u0430\u043B\u0438\u0442\u044C", cancelText: "\u041E\u0442\u043C\u0435\u043D\u0430", onConfirm: () => __awaiter(void 0, void 0, void 0, function* () {
                    yield onDelete(note.id);
                    setConfirmOpen(false);
                }) })] }));
};
export default NoteListItem;
